import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

export type KeyDialogRenderer = (open: boolean, setOpen: (value: boolean) => void) => ReactNode;

export const KeyDialogContext = createContext<KeyDialogRenderer | null>(null);

export const useKeyDialog = () => useContext(KeyDialogContext);
